module.exports = __webpack_public_path__ + "static/hero1-bcb88255b4fc7bb73d3bf511ed30c854.jpg";